const GET_CONFIG = '/config/cp-epp';
const UPDATE_CONFIG = '/config/cp-epp';
const GET_IEXAM_CONFIG = '/config/iExam';
const UPDATE_IEXAM_CONFIG = '/config/iExam';
const GET_IEXAM_COUNTRY_CODE = '/config/iexam/COUNTRY_CODE_CD';
const GET_IEXAM_BIRTH_COUNTRY_CODE = '/config/iexam/BIRTH_CTRY_CD';

const ROUTE = {
  GET_CONFIG,
  UPDATE_CONFIG,
  GET_IEXAM_CONFIG,
  UPDATE_IEXAM_CONFIG,
  GET_IEXAM_COUNTRY_CODE,
  GET_IEXAM_BIRTH_COUNTRY_CODE,
};

export { ROUTE };
